module.exports = __webpack_public_path__ + "img/background.c62837fd.jpg";